module.exports = __webpack_public_path__ + "static/media/product.13ce8951.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/product.png
// module id = 813
// module chunks = 0